<!--
  Admin mode › Flexi › Settings › Safety round templates: the application's safety
  round templates, which of them new businesses get, and who has each one.
-->
<flexi-settings-nav></flexi-settings-nav>

<div class="fvr-lib" [attr.aria-busy]="loading">
  <section class="fvr-lib__main">
    <header class="fvr-head">
      <div class="fvr-lib__heading">
        <h2 class="fvr-title">{{ 'FLEXI_SAFETY_ROUNDS.LIBRARY.TITLE' | translate }}</h2>
        <p class="fvr-subtitle">{{ 'FLEXI_SAFETY_ROUNDS.LIBRARY.INTRO' | translate }}</p>
      </div>
      <button type="button" class="fas-btn fas-btn--primary" (click)="openCreate()">
        <i class="pi pi-plus" aria-hidden="true"></i>{{ 'FLEXI_SAFETY_ROUNDS.LIBRARY.NEW' | translate }}
      </button>
    </header>

    <div class="fvr-lib__toolbar">
      <label class="fvr-search">
        <span class="fas-sr-only">{{ 'FLEXI_SAFETY_ROUNDS.LIBRARY.SEARCH' | translate }}</span>
        <i class="pi pi-search" aria-hidden="true"></i>
        <input
          pInputText
          type="search"
          maxlength="200"
          [(ngModel)]="search"
          (ngModelChange)="applyFilter()"
          [placeholder]="'FLEXI_SAFETY_ROUNDS.LIBRARY.SEARCH' | translate"
        />
      </label>
      <div class="fvr-filter" role="group" [attr.aria-label]="'FLEXI_SAFETY_ROUNDS.LIBRARY.STATUS_FILTER' | translate">
        @for (f of filters; track f.labelKey) {
          <button
            type="button"
            class="fvr-filter__chip"
            [class.fvr-filter__chip--active]="status === f.value"
            [attr.aria-pressed]="status === f.value"
            (click)="pickStatus(f.value)"
          >
            {{ f.labelKey | translate }}
            <span class="fvr-filter__count">{{ count(f.value) }}</span>
          </button>
        }
      </div>
    </div>

    @if (loadFailed) {
      <p class="fas-error" role="alert">{{ 'FLEXI_SAFETY_ROUNDS.LOAD_FAILED' | translate }}</p>
      <button type="button" class="fas-btn fas-btn--ghost" (click)="load()">{{ 'FLEXI_SAFETY_ROUNDS.ASSIGN.RETRY' | translate }}</button>
    }

    @if (loading) { <flexi-safety-round-skeleton /> }
    @if (busyIds.size || creating) { <p class="fvr-action-status" role="status">{{ 'FLEXI_SAFETY_ROUNDS.SAVING' | translate }}</p> }
    <div class="fvr-table-card" *ngIf="!loading && !loadFailed">
      <p-table
        [value]="visible"
        dataKey="Id"
        [loading]="loading"
        [rows]="20"
        [paginator]="visible.length > 20"
        [rowHover]="true"
        styleClass="p-datatable-sm"
        [tableStyle]="{ 'min-width': '56rem' }"
      >
        <ng-template pTemplate="header">
          <tr>
            <th>{{ 'FLEXI_SAFETY_ROUNDS.LIBRARY.COLUMN_TEMPLATE' | translate }}</th>
            <th>{{ 'FLEXI_SAFETY_ROUNDS.LIBRARY.COLUMN_CONTENT' | translate }}</th>
            <th>{{ 'FLEXI_SAFETY_ROUNDS.LIBRARY.COLUMN_ASSIGNED' | translate }}</th>
            <th>{{ 'FLEXI_SAFETY_ROUNDS.LIBRARY.COLUMN_DEFAULT' | translate }}</th>
            <th>{{ 'FLEXI_SAFETY_ROUNDS.COLUMN.STATUS' | translate }}</th>
            <th class="fvr-lib__action-col"><span class="fas-sr-only">{{ 'ACTIONS' | translate }}</span></th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-t>
          <tr>
            <td>
              <div class="fvr-lib__name">
                <a class="fvr-link" href="javascript:void(0)" (click)="open(t)">{{ t.Name }}</a>
                <span class="fas-muted">
                  {{ 'FLEXI_SAFETY_ROUNDS.VERSION' | translate: { version: t.Version } }}
                  · {{ 'FLEXI_SAFETY_ROUNDS.LIBRARY.CHANGED' | translate: { date: ((t.ModifiedOn || t.CreatedOn) | date: 'dd-MM-yyyy') } }}
                  @if (t.Industry) {
                    · {{ t.Industry }}
                  }
                </span>
              </div>
            </td>
            <td class="fvr-num">
              {{ 'FLEXI_SAFETY_ROUNDS.LIBRARY.CONTENT' | translate: { items: t.ItemCount, sections: t.SectionCount } }}
            </td>
            <td class="fvr-num">
              <button
                type="button"
                class="fas-btn fas-btn--text"
                [attr.aria-label]="'FLEXI_SAFETY_ROUNDS.ASSIGN.MANAGE_TITLE' | translate: { name: t.Name }"
                (click)="openAssign(t)"
              >
                {{ 'FLEXI_SAFETY_ROUNDS.LIBRARY.ASSIGNED_COUNT' | translate: { count: t.AssignedCount } }}
              </button>
            </td>
            <td>
              <button
                type="button"
                role="switch"
                class="fvr-switch"
                [attr.aria-checked]="t.IsDefaultForNewBusinesses"
                [attr.aria-label]="'FLEXI_SAFETY_ROUNDS.LIBRARY.DEFAULT_ARIA' | translate: { name: t.Name }"
                [disabled]="!isPublished(t) || busyIds.has(t.Id)"
                [pTooltip]="!isPublished(t) ? ('FLEXI_SAFETY_ROUNDS.LIBRARY.DEFAULT_NEEDS_PUBLISHED' | translate) : ''"
                (click)="toggleDefault(t)"
              ></button>
            </td>
            <td>
              <span class="fvr-pill" [ngClass]="statusClass(t.Status)">{{ statusKey(t.Status) | translate }}</span>
            </td>
            <td class="fvr-lib__action-col">
              @if (isPublished(t)) {
                <button type="button" class="fas-btn fas-btn--text" (click)="openAssign(t)">
                  {{ 'FLEXI_SAFETY_ROUNDS.LIBRARY.ASSIGN' | translate }}
                </button>
              }
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
          <tr>
            <td colspan="6">
              <div class="fvr-empty">
                <i class="pi pi-inbox" aria-hidden="true"></i>
                <p>{{ 'FLEXI_SAFETY_ROUNDS.LIBRARY.EMPTY' | translate }}</p>
              </div>
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </section>

  <aside class="fvr-lib__side" *ngIf="!loading && !loadFailed">
    <section class="fvr-card fvr-lib__aside-card">
      <span class="fvr-eyebrow">{{ 'FLEXI_SAFETY_ROUNDS.LIBRARY.NEW_BUSINESSES_GET' | translate }}</span>
      <strong>{{ defaultsForNew.length ? defaultsForNewNames : ('FLEXI_SAFETY_ROUNDS.LIBRARY.NO_DEFAULTS' | translate) }}</strong>
      <p class="fas-muted">{{ 'FLEXI_SAFETY_ROUNDS.LIBRARY.NEW_BUSINESSES_NOTE' | translate }}</p>
    </section>
    @if (drafts.length) {
      <section class="fvr-card fvr-lib__aside-card">
        <span class="fvr-eyebrow">{{ 'FLEXI_SAFETY_ROUNDS.TEMPLATE_STATUS.0' | translate }}</span>
        <p class="fas-muted">{{ 'FLEXI_SAFETY_ROUNDS.LIBRARY.DRAFTS_NOTE' | translate: { names: draftNames } }}</p>
      </section>
    }
    <p class="fas-note">
      <i class="pi pi-info-circle" aria-hidden="true"></i>
      <span>{{ 'FLEXI_SAFETY_ROUNDS.LIBRARY.SNAPSHOT_NOTE' | translate }}</span>
    </p>
  </aside>
</div>

@if (assigning; as t) {
  <flexi-safety-round-assign-drawer
    [templateId]="t.Id"
    [templateName]="t.Name"
    [canAssign]="isPublished(t)"
    (closed)="assignClosed($event)"
  ></flexi-safety-round-assign-drawer>
}

<p-dialog
  [visible]="createOpen"
  (visibleChange)="$event ? null : closeCreate()"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [closable]="!creating"
  [style]="{ width: '560px', maxWidth: '95vw' }"
  [header]="'FLEXI_SAFETY_ROUNDS.LIBRARY.NEW_TITLE' | translate"
>
  <form class="fvr-create" id="fvr-create-form" (ngSubmit)="create()">
    <div class="fvr-field">
      <label for="fvr-new-name">{{ 'FLEXI_SAFETY_ROUNDS.EDITOR.NAME' | translate }} <span class="fvr-required">*</span></label>
      <input pInputText id="fvr-new-name" name="name" type="text" maxlength="200" [(ngModel)]="newName" />
    </div>
    <div class="fvr-field">
      <label for="fvr-new-industry">{{ 'FLEXI_SAFETY_ROUNDS.EDITOR.INDUSTRY' | translate }}</label>
      <input pInputText id="fvr-new-industry" name="industry" type="text" maxlength="200" [(ngModel)]="newIndustry" />
    </div>
    <div class="fvr-field">
      <label for="fvr-new-description">{{ 'FLEXI_SAFETY_ROUNDS.EDITOR.DESCRIPTION' | translate }}</label>
      <textarea pTextarea id="fvr-new-description" name="description" rows="3" maxlength="2000" [(ngModel)]="newDescription"></textarea>
    </div>
  </form>

  <ng-template pTemplate="footer">
    <div class="fas-dialog-actions fvr-create__actions">
      <button type="button" class="fas-btn fas-btn--ghost" [disabled]="creating" (click)="closeCreate()">{{ 'CANCEL' | translate }}</button>
      <button type="submit" form="fvr-create-form" class="fas-btn fas-btn--primary" [disabled]="creating || !newName.trim()">
        @if (creating) {
          <i class="pi pi-spin pi-spinner" aria-hidden="true"></i>
        }
        {{ (creating ? 'FLEXI_SAFETY_ROUNDS.SAVING' : 'FLEXI_SAFETY_ROUNDS.LIBRARY.CREATE') | translate }}
      </button>
    </div>
  </ng-template>
</p-dialog>
